import { ENDPOINTS } from "../config/endpoints";

export const matchSchema = {
  steps: [
    {
      title: "Match Setup",
      fields: [
        {
          name: "competition",
          type: "select",
          displayName: "Competition",
          fetch: ENDPOINTS.competitions.myCompetitions,
        },
        // A match can belong to a Competition OR a Series (bilateral) — not
        // both. Backend enforces "exactly one" at the serializer; if both
        // are set on submit, the user gets a validation error.
        {
          name: "series",
          type: "select",
          displayName: "Series (use Series OR Competition, not both)",
          fetch: ENDPOINTS.competitions.mySeries,
        },
        {
          name: "match_type",
          type: "select",
          displayName: "Match Type",
          required: true,
          fetch: ENDPOINTS.matches.matchTypes,
          // 2026-05-26: Test format previously hidden from B2C dropdowns
          // via hideOptionLabelsForB2C. Founder asked to enable Test for
          // B2C users (team testing). Backend allowed_formats whitelist
          // on all B2C plans now includes "TEST"; this client-side filter
          // is removed in sync.
        },
        // 2026-06-23 — Tournament's own fixture number (e.g. "Match 14"
        // of IPL 2026). 2026-06-24 — promoted to required after audit
        // found 0/65 user-coded matches had it populated; the /admin/
        // matches list relies on it for natural tournament ordering,
        // and the founder wants every future coded match to carry one
        // (friendlies use 1/2/3 sequence too).
        {
          name: "match_number",
          type: "text",
          inputType: "number",
          required: true,
          displayName: "Match Number (within tournament / series)",
          placeholder: "e.g. 1, 2, 14 (fixture number)",
        },
        {
          name: "team1",
          type: "select",
          displayName: "Team 1",
          required: true,
          fetch: ENDPOINTS.coredata.teams,
        },
        {
          name: "team2",
          type: "select",
          displayName: "Team 2",
          required: true,
          fetch: ENDPOINTS.coredata.teams,
        },
        {
          name: "stadium",
          type: "select",
          displayName: "Stadium",
          fetch: ENDPOINTS.coredata.stadiums,
        },
        {
          name: "drs_count",
          type: "text",
          inputType: "number",
          displayName: "DRS Count",
        },
        {
          name: "floodlights_count",
          type: "text",
          inputType: "number",
          displayName: "Floodlights Count",
        },
      ],
    },
    {
      title: "Schedule",
      fields: [
        {
          name: "match_date",
          type: "text",
          inputType: "date",
          displayName: "Match Date",
          required: true,
        },
        {
          name: "start_time",
          type: "text",
          inputType: "time",
          displayName: "Start Time",
        },
        {
          name: "match_mode",
          type: "select",
          displayName: "Match Mode",
          optionsKey: "MATCH_MODES",
        },
        {
          name: "umpires",
          type: "multiselect",
          displayName: "Umpires",
          fetch: ENDPOINTS.coredata.umpires,
        },
        {
          name: "third_umpire",
          type: "select",
          displayName: "Third Umpire (TV)",
          fetch: ENDPOINTS.coredata.umpires,
        },
        {
          name: "fourth_umpire",
          type: "select",
          displayName: "Reserve Umpire",
          fetch: ENDPOINTS.coredata.umpires,
        },
        {
          name: "match_referee",
          type: "select",
          displayName: "Referee",
          fetch: ENDPOINTS.coredata.umpires,
        },
      ],
    },
    // CF-P1-04 — Pre-match Powerplay override. 2026-06-10 — the
    // `is_rain_affected` boolean was REMOVED from this step per founder
    // ask. Operators flip rain-affected status (with overs reduction)
    // from BBP More Options → "Rain affected at start" once they're
    // ready to start scoring; the match-creation form should stay
    // focused on setup, not weather contingencies. powerplay_override
    // stays here so operators with non-default first-Powerplay rules
    // can still pre-configure them.
    {
      title: "Powerplay override (optional)",
      fields: [
        {
          name: "powerplay_override",
          type: "powerplay_override",
          displayName: "Powerplay override",
        },
      ],
    },
  ],
};
